import axios from "axios"

export const getAceptar = async (comercios:any) => {
    return axios.post('api/Login/Authenticate', comercios)
}


export const getVerify = async () => {
    return axios.get('api/Login/Verify')
        .catch(err => err);
}

export const requestMfa = async (login: any) => {
    return axios.get(`api/Login/RequestMFA?login=${login}`)
};

export const verifyMfa = async (code: any) => {
  return axios.post('api/Login/VerifyCodeMFA', code );
};


